import * as pubsub from "pubsub-js";

export enum CommunityEvent {
	CommunityCreated = "community.created",
	JoinedCommunity = "community.membership.joined",
	LeftCommunity = "community.membership.left",
	CommunityDeleted = "community.deleted"
}

type Data<T extends CommunityEvent> =
	T extends CommunityEvent.CommunityCreated ? { id: number; name: string; isMember: boolean; } :
	T extends CommunityEvent.JoinedCommunity ? { id: number; name: string; } :
	T extends CommunityEvent.LeftCommunity ? { communityId: number; } :
	T extends CommunityEvent.CommunityDeleted ? { communityId: number; } :
	never;

export const subscribe: <T extends CommunityEvent>(kind: T, callback: (message: string, data: Data<T>) => void) => PubSubSubscriptionToken = pubsub.subscribe;
export const publish: <T extends CommunityEvent>(kind: T, data: Data<T>) => void = pubsub.publish;
export const unsubscribe: (token: PubSubSubscriptionToken) => void = pubsub.unsubscribe;
